<template>
  <div>
    <!-- MENSAJE DEL SISTEMA -->
    <mensajeSistema></mensajeSistema>
    <br />
    <v-card>
      <v-tabs
        v-model="tab"
        color="yellow darken-3"
        background-color="grey lighten-4"
        centered
        grow
      >
        <v-menu>
          <template v-slot:activator="{ attrs }">
            <v-tooltip bottom color="#1b1b1b" class="mx-2">
              <template v-slot:activator="{ on }">
                <v-btn
                  class="align-self-center mr-4"
                  @click="resetearCampos()"
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="green"
                >
                  <v-icon>mdi-cached</v-icon>
                </v-btn>
              </template>
              <span>Refrescar selectores</span>
            </v-tooltip>
          </template>
        </v-menu>
        <v-tabs-slider></v-tabs-slider>

        <v-tab
          v-for="(item, indexh) in dataTabs"
          :key="indexh"
          :href="`#${indexh + 1}`"
        >
          <v-icon left>far fa-file-pdf</v-icon> {{ item.title }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="(content, indexc) in dataTabs"
          :key="indexc"
          :value="`${indexc + 1}`"
        >
          <br />
          <v-card>
            <v-card-text>
              <v-row class="px-4">
                <v-col cols="12" md="3">
                  <v-select
                    :items="anoslectivos"
                    v-model="anoLectivoDato"
                    @change="changeAniolectivo"
                    label="Año lectivo"
                    item-text="nom_anolectivo"
                    item-value="id"
                    hide-details
                    return-object
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-select
                    :items="niveles"
                    v-model="nivelesDato"
                    label="Nivel"
                    @change="changeNivel"
                    :disabled="disabledNivel"
                    item-text="desc_nivel"
                    item-value="id_nivel"
                    hide-details
                    return-object
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-select
                    :items="grados"
                    v-model="gradosDato"
                    @change="changeGrado"
                    label="Grado"
                    item-text="desc_grado"
                    :disabled="disabledGrado"
                    item-value="id"
                    hide-details
                    return-object
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field
                    label="Buscar"
                    v-model="search"
                    append-icon="fa-search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- FILTROS Y SEARCHBAR -->
              <component
                :is="content.componente"
                :estado="content.estadoComponente"
                :parametros="parametros"
                :searchProp="search"
              >
              </component>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import axios from "@/helpers/axios";
// eslint-disable-next-line no-unused-vars
import { mapMutations } from "vuex";
import AutocompleteComp from "../../../components/ComponentsEst/AutocompleteComp.vue";
import HistorialConglomerado from "./componentsHistorial/HistorialConglomerado.vue";
import HistorialCierreAño from "./componentsHistorial/HistorialCierreAño.vue";
import HistorialCursosAcargo from "./componentsHistorial/HistorialCursosAcargo.vue";
import HistorialRecuperacion from "./componentsHistorial/HistorialRecuperacion.vue";

export default {
  name: "HistorialSituacionFinal",
  components: {
    AutocompleteComp,
    HistorialConglomerado,
    HistorialCierreAño,
    HistorialRecuperacion,
    HistorialCursosAcargo,
  },
  props: ["tabPosition"],
  data: () => ({
    niveles: [],
    nivelesDato: null,
    grados: [],
    gradosDato: null,
    anoslectivos: [],
    anoLectivoDato: null,
    search: "",
    dataTabs: [
      {
        title: "Historial conglomerado",
        componente: "HistorialConglomerado",
        estadoComponente: false,
      },
      {
        title: "Historial cierre del año",
        componente: "HistorialCierreAño",
        estadoComponente: false,
      },
      {
        title: "Historial recuperación",
        componente: "HistorialRecuperacion",
        estadoComponente: false,
      },
      {
        title: "Historial subsanación",
        componente: "HistorialCursosAcargo",
        estadoComponente: false,
      },
    ],
    tab: null,
    nivelSelected: -1,
    gradoSelected: -1,
    seccionSelected: -1,
    searchQuery: "",

    anolectivo: [],
    datoLogin: sessionStorage,
    disabledNivel: true,
    disabledGrado: true,
    parametros: {
      id_ano_lectivo: null,
      id_nivel_ck1: null,
      id_grado_ck1: null,
    },
  }),
  watch: {
    tabPosition(valor) {
      if (valor == 3) {
        console.log(valor);
        this.loadMain();
      }
      // this.resetearCampos();
    },
  },
  mounted() {
    this.loadMain();
  },
  methods: {
    /*______________________
    │   * Método inicio     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    loadMain() {
      this.getAnosLectivos();
    },
    /*______________________________________________
    │   * Método para obtener los años lectivos     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async getAnosLectivos() {
      const id_colegio = Number(this.datoLogin.id_colegio);

      try {
        const { data } = await axios.get(
          `/cierreanio/cierreanioituacionestudiante/getAnoLectivos/${id_colegio}`
        );

        this.anoslectivos = data;
      } catch (error) {
        console.error(error);
      }
    },
    /*________________________________________
    │   * Método para obtener los niveles     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async getNiveles(id_ano_lectivo) {
      this.niveles = [];
      const id_colegio = Number(this.datoLogin.id_colegio);

      try {
        const { data } = await axios.post(
          "/cierreanio/cierreanioituacionestudiante/getNiveles",
          { id_ano_lectivo, id_colegio }
        );

        const datos = data.length > 0 ? data : new Array();
        this.niveles = datos;
        this.disabledNivel = false;
      } catch (error) {
        console.error(error);
      }
    },
    /*_______________________________________
    │   * Método para obtener los grados     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async getGrados(idNivel, id_ano_lectivo) {
      this.grados = [];
      const id_colegio = Number(this.datoLogin.id_colegio);

      try {
        const { data } = await axios.post(
          "/cierreanio/cierreanioituacionestudiante/getGrados",
          {
            idNivel: idNivel,
            id_colegio,
            id_ano_lectivo,
          }
        );

        const datos = data.length > 0 ? data : new Array();
        this.grados = datos;
        this.disabledGrado = false;
      } catch (error) {
        console.error(error);
      }
    },
    /*____________________________________
    │   * Método para cambiar niveles     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    changeNivel(event) {
      this.parametros.id_nivel_ck1 = event.id_nivel_clickone;
      this.parametros.id_grado_ck1 = null;
      this.getGrados(event.id_nivel, event.id_ano_lectivo);
    },
    /*____________________________________
    │   * Método para cambiar niveles     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    changeGrado(event) {
      this.parametros.id_grado_ck1 = event.id_grado_clickone;
    },
    /*________________________________________
    │   * Método para cambiar Año lectivo     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    changeAniolectivo({ id }) {
      this.parametros.id_ano_lectivo = id;
      this.parametros.id_nivel_ck1 = null;
      this.parametros.id_grado_ck1 = null;

      this.niveles = [];
      this.grados = [];
      this.nivelesDato = null;
      this.gradosDato = null;
      this.getNiveles(id);
    },
    /*____________________________________
    │   * Método para resetear campos     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    resetearCampos() {
      this.nivelesDato = null;
      this.gradosDato = null;
      this.anoLectivoDato = null;

      this.niveles = [];
      this.grados = [];
      this.anoslectivos = [];

      this.disabledNivel = true;
      this.disabledGrado = true;

      this.parametros = {
        id_ano_lectivo: null,
        id_nivel_ck1: null,
        id_grado_ck1: null,
      };

      this.search = "";

      this.getAnosLectivos();
    },
  },
};
</script>
